import { render, staticRenderFns } from "./ManageDispatchEntities.vue?vue&type=template&id=0ea19bbc&scoped=true"
import script from "./ManageDispatchEntities.vue?vue&type=script&lang=js"
export * from "./ManageDispatchEntities.vue?vue&type=script&lang=js"
import style0 from "./ManageDispatchEntities.vue?vue&type=style&index=0&id=0ea19bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea19bbc",
  null
  
)

export default component.exports